import { defineMessages } from "react-intl";

const messages = defineMessages({
  currencyError: {
    id: "settings.manageFields.editPane.currencyId.error",
    defaultMessage: "Currency is required",
    description: "Manage Fields - Currency error text",
  },
  currencyTitle: {
    id: "settings.manageFields.editPane.currency.title",
    defaultMessage: "Select Currency",
    description: "Settings Custom field - new monetary CF currency title",
  },
  editPaneTitle: {
    id: "settings.manageFields.editPane.title",
    defaultMessage: "Edit Field",
    description: "Manage Fields - title of Edit Field pane",
  },
  error: {
    id: "settings.manageFields.editPane.name.error",
    defaultMessage: "Field name is required",
    description: "Manage Fields - Name error text",
  },
  expressionDescription: {
    id: "settings.manageFields.editPane.expressionDescription",
    defaultMessage: "Description",
    description: "Manage Fields - expression Description",
  },
  format: {
    id: "settings.manageFields.editPane.numeric.format.title",
    defaultMessage: "Format",
    description: "Settings Custom field - new numeric CF format title",
  },
  markUnique: {
    id: "settings.manageFields.editPane.markUnique",
    defaultMessage: "Values must be unique",
    description: "Mark custom field as unique title",
  },
  nameTitle: {
    id: "settings.manageFields.editPane.name.title",
    defaultMessage: "Field name",
    description: "Manage Fields - Name title",
  },
  placeholder: {
    id: "settings.manageFields.editPane.placeholder.placeholder",
    defaultMessage: "Pick something descriptive and unique to guide your team",
    description: "Manage Fields - Placeholder",
  },
  placeholderTitle: {
    id: "settings.manageFields.editPane.placeholder.title",
    defaultMessage: "Placeholder text",
    description: "Manage Fields - Placeholder title",
  },
  saveButton: {
    id: "settings.manageFields.editPane.footer.saveButton",
    defaultMessage: "Save Changes",
    description: "Manage Fields - Save Changes button title",
  },
});

export default messages;
